const APIS = {
  USER: "/usermanagementservice/api/user/",
  API_KEY: "/apiservice/api/v1/api-key/"
};

export default APIS;